import { isAuthenticated, getTokenProperty } from 'web-fns/dist/auth'

interface TBrand {
  current_brand_uuid: string
  brands: Array<{ role: string; uuid: string }>
}

export const getCurrentBrand = () => {
  const associatedBrands = getTokenProperty<TBrand['brands']>('brands')

  if (!associatedBrands || associatedBrands.length === 0) {
    return
  }

  const currentBrandUuid = getTokenProperty<TBrand['current_brand_uuid']>(
    'current_brand_uuid'
  )

  return associatedBrands.find(
    brand => brand.uuid === currentBrandUuid && brand.role === 'admin'
  )
}

export const isBrandAdmin = () =>
  isAuthenticated() && getCurrentBrand() !== undefined

export * from 'web-fns/dist/auth'



// WEBPACK FOOTER //
// ./src/helpers/auth.ts